// extracted by mini-css-extract-plugin
module.exports = {"status":"MessageListItemStatus_status__1pM8P","icon":"MessageListItemStatus_icon__1VSt0"};